var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams } from "react-router-dom";
const NavigateWithParams = (_a) => {
    var { to } = _a, rest = __rest(_a, ["to"]);
    const params = useParams();
    let toValue;
    if (typeof to === 'function') {
        toValue = to(params);
    }
    else {
        toValue = to;
    }
    return _jsx(Navigate, Object.assign({}, rest, { to: toValue }));
};
export default NavigateWithParams;
